export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пароль"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отмена"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Продолжить"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите пароль подтверждения"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пароль подтверждения"])}
}